import React from 'react';

const Calendar = () => {
  return (
    <div className="bg-white p-4 rounded-lg border">
      <div className="text-center mb-4">
        <div className="text-sm text-gray-500">MON</div>
        <div className="text-2xl font-semibold">11</div>
      </div>
      <div className="space-y-6">
        {Array.from({ length: 12 }).map((_, index) => (
          <div key={index} className="relative">
            <div className="absolute left-0 text-sm text-gray-500">{index + 1} PM</div>
            <div className="ml-12 h-6 border-b border-gray-200">
              {index === 6 && (
                <div className="absolute w-full bg-blue-100 p-1 rounded text-sm">
                  IG standup evening, 6.30pm
                </div>
              )}
              {index === 11 && (
                <div className="absolute w-full bg-green-100 p-1 rounded text-sm">
                  Do journal, 10:40pm
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Calendar;